import { render } from "./CheckoutWhiteFaq.vue?vue&type=template&id=4a2473e2&scoped=true"
import script from "./CheckoutWhiteFaq.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteFaq.vue?vue&type=script&lang=js"

import "./CheckoutWhiteFaq.vue?vue&type=style&index=0&id=4a2473e2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2473e2"]])

export default __exports__